import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { AxiosResponse } from 'axios'
import { IInventoryTransferModal } from 'pages/Inventory/Transfers/InventoryTransferModal'
import { toast } from 'react-toastify'
import { IPaginatedResponse } from 'types/api/general.interface'
import {
  IGetAllInventoryReceiptsSingleResponse,
  IInventoryTransferPostRequest,
} from 'types/api/inventoryReceiptsApi.interface'
import { IInventoryTransfersSlice } from 'types/inventory.interface'
import { baseUrl } from 'utils/axios'
import { formatParams, getParams, handleErrors } from 'utils/helpers'

const initialState: IInventoryTransfersSlice = {
  isLoading: false,
  transfers: [],
  totalCount: 0,
  totalPages: 0,
}

export const getInventoryTransfers = createAsyncThunk(
  'inventoryTransfers/getInventoryTransfers',
  async (params: any, thunkAPI) => {
    try {
      params = formatParams(params)
      const resp: AxiosResponse<IPaginatedResponse<IGetAllInventoryReceiptsSingleResponse>> =
        await baseUrl.get('inventory/transfer', { params })
      return resp.data
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  },
)

export const addInventoryTransfer = createAsyncThunk(
  'inventoryTransfers/addInventoryTransfer',
  async (data: IInventoryTransferModal, thunkAPI) => {
    const request: IInventoryTransferPostRequest = {
      transactionDate: data.transactionDate.toISOString(),
      fromLocationId: data.fromLocation.value,
      toLocationId: data.toLocation.value,
      lines: data.lines.map((l) => ({
        itemId: l.item.value,
        quantity: l.quantity,
      })),
    }
    try {
      const resp: AxiosResponse = await baseUrl.post('inventory/transfer/', request)
      await thunkAPI.dispatch(getInventoryTransfers(getParams({ location, limit: 30 })))
      return resp.data
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  },
)

const inventoryTransfersSlice = createSlice({
  name: 'inventoryTransfers',
  initialState,
  reducers: {
    clearInventoryTransfers(state) {
      state.totalCount = 0
      state.totalPages = 0
      state.transfers = []
    },
  },
  extraReducers: {
    [getInventoryTransfers.pending.type]: (state) => {
      state.isLoading = true
    },
    [getInventoryTransfers.fulfilled.type]: (state, { payload }) => {
      state.isLoading = false
      state.transfers = payload.data
      state.totalPages = payload.totalPages
      state.totalCount = payload.totalCount
    },

    [getInventoryTransfers.pending.type]: (state) => {
      state.isLoading = true
    },
    [addInventoryTransfer.pending.type]: (state) => {
      state.isLoading = true
    },
    [addInventoryTransfer.fulfilled.type]: (state) => {
      state.isLoading = false
      toast.success('Transfer successfully added')
    },
    [addInventoryTransfer.rejected.type]: (state, { payload }) => {
      state.isLoading = false
      handleErrors(payload)
    },
  },
})

export const { clearInventoryTransfers } = inventoryTransfersSlice.actions

export default inventoryTransfersSlice.reducer
